import { Box, BoxProps } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { useTranslation } from 'react-i18next';
import React, { FC, ReactElement } from 'react';
import { mq } from 'styles/breakpoints';
import BoxContent from '../BoxContent/BoxContent';
import BoxHeader from '../BoxHeader/BoxHeader';
import BoxMain from '../BoxMain/BoxMain';
import { isCorporateThemeSelector } from 'modules/app/appSlice';
import { useSelector } from 'react-redux';
import { ShepherdTour } from 'react-shepherd';
import { steps, tourOptions } from 'utils/shepherdConfirmationOptions';
import ShepherdConfirmation from './ShepherdConfirmation';

interface ImpactProps {
  boxWidth?: BoxWidth;
  animate?: boolean;
  boxes: ReactElement[];
  title: string | ReactElement;
  wrap?: boolean;
}

const Wrapper = styled(Box)<BoxProps & { boxCount: number }>`
  flex-direction: column;
  align-items: center;
  display: flex;
  margin-top: 20px;

  ${mq.md} {
    flex-direction: row;
    justify-content: space-between;

    & > div {
      width: ${({ boxCount }): string => {
        switch (boxCount) {
          case 2:
            return '50%';
          case 3:
            return 'auto';
          default:
            return '100%';
        }
      }};
    }

    & > div:first-of-type {
      min-width: 330px;
      padding-right: 14px;
    }
  }
`;

const Impact: FC<ImpactProps> = ({ boxWidth = 'md', animate, wrap, boxes, title }) => {
  const { ready } = useTranslation('common');
  const isCorporateTheme = useSelector(isCorporateThemeSelector);

  return (
    <ShepherdTour steps={steps} tourOptions={tourOptions}>
      <ShepherdConfirmation />
      <BoxContent boxWidth={boxWidth} includeRightMargin transparent animate={animate} height="100%" className="impact-module" id="impact-module">
        <BoxMain ready={ready} overlayHeight="300px" overlayType="splitted" display="flex" flexDir="column" height="100%">
          <BoxHeader>
            <span>{title}</span>
          </BoxHeader>
          <Wrapper
            boxCount={boxes.length}
            flexWrap={wrap ? 'wrap' : 'nowrap'}
            pb={[0, 0, 0, '20px']}
            mb={isCorporateTheme ? 0 : [0, 0, 0, 0, 0, '35px']}
          >
            {boxes}
          </Wrapper>
        </BoxMain>
      </BoxContent>
    </ShepherdTour>
  );
};

export default Impact;
